var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jumbotron background"},[_c('div',{staticClass:"container"},[_c('img',{attrs:{"src":require("../../../assets/logo.png"),"width":"160px","alt":"logo"}}),_c('p',[_vm._v("This is a student project of the FHNW.")])])])}]
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5df67a79","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./src/app/components/Head/Head.html
// module id = null
// module chunks = 